"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.GetPhoneDynamicCodeForAppletsRequest = void 0;
var GetPhoneDynamicCodeForAppletsRequest = /** @class */ (function () {
    function GetPhoneDynamicCodeForAppletsRequest() {
    }
    return GetPhoneDynamicCodeForAppletsRequest;
}());
exports.GetPhoneDynamicCodeForAppletsRequest = GetPhoneDynamicCodeForAppletsRequest;
//# sourceMappingURL=getPhoneDynamicCodeForApplets.request.js.map